import styled from 'styled-components'
import { Typography } from '@material-ui/core'

export const NoRecordLabel = styled(Typography).attrs({
	variant: 'h4'
})`
	font-weight: 500;
`
